// mac App.jsx articles / faqItems；暂停能力按本批接口状态修正。
export const articles=[
  {
    "date": "开始使用",
    "title": "安装助手，完成第一次连接",
    "text": "查看 Windows 与 Mac 的安装前检查；客户端安装包待发布，可先了解助手、Codex 与 Skills 的区别。",
    "faqId": "faq-install"
  },
  {
    "date": "账户与订单",
    "title": "登录账户，查看余额与订单",
    "text": "查看当前账户的人民币余额，区分查询状态与订单到账状态。",
    "faqId": "faq-account"
  },
  {
    "date": "Skill 技能",
    "title": "从一个实用项目开始",
    "text": "免费下载 Skills 单项或合集安装说明包，再将文件和完整指令一起发给 macOS Codex。",
    "faqId": "faq-skills"
  },
  {
    "date": "图片生成",
    "title": "文字生图：先确认模型授权",
    "text": "当前支持文字生图，一次一张；登录后确认模型授权并获取报价，暂不支持参考图与并发生成。",
    "faqId": "faq-image"
  },
  {
    "date": "视频复刻",
    "title": "整理素材，说明替换与保留的内容",
    "text": "整理参考素材与创作要求，上传及保存能力以页面实际开放状态为准。",
    "faqId": "faq-video"
  },
  {
    "date": "草稿与成果",
    "title": "了解草稿与成果的保存方式",
    "text": "保存与跨设备恢复以实际服务状态为准，请保留重要原始文件。",
    "faqId": "faq-drafts"
  },
  {
    "date": "首页与站点",
    "title": "预览动态首页与展示效果",
    "text": "预览十二种动态首页，了解主题、语言与站点发布的区别。",
    "faqId": "faq-appearance"
  },
  {
    "date": "问题与支持",
    "title": "遇到问题，先确认当前状态",
    "text": "查看连接检查步骤、个人中心服务状态，以及求助时需要准备的信息。",
    "faqId": "faq-support"
  }
] as const;
export const faqItems=[
  {
    "id": "faq-install",
    "question": "第一次使用，应该从哪里开始？",
    "answer": "先查看安装说明与当前发布状态；客户端安装包待发布，可先阅读使用指南或获取 Skills 安装说明包。获取正式安装包后核对系统要求，再按指引安装助手、连接账户并检查 Codex 与模型状态。",
    "href": "#download",
    "action": "前往一键安装"
  },
  {
    "id": "faq-systems",
    "question": "Windows 和 Mac 的安装步骤一样吗？",
    "answer": "两平台的安装步骤不同。客户端安装包目前待发布；获取正式安装包后，先核对系统、架构与版本要求。Windows 按安装包指引操作；Mac 按 PKG 指引安装助手，再准备或选择已有 Codex。安装助手和准备 Codex 是两个步骤。",
    "href": "#tutorial",
    "action": "查看安装与使用指南"
  },
  {
    "id": "faq-account",
    "question": "在哪里查看我的账户、余额和订单？",
    "answer": "使用当前站点账户登录后进入“个人中心”，查看当前账户的人民币余额与累计消费。余额查询失败时不会显示为零。订单、资料和通知将在服务开放后提供。",
    "href": "#account",
    "action": "前往个人中心"
  },
  {
    "id": "faq-payment",
    "question": "已经付款，为什么还没有显示到账？",
    "answer": "先确认登录的是购买时的账户。付款已确认、到账处理中与已到账是不同状态；页面查询失败也不等于付款失败。当前网页订单服务尚待开放，请保留订单号与付款记录，联系为你提供服务的客服核对，确认原订单结果后再决定下一步。"
  },
  {
    "id": "faq-skills",
    "question": "Skill 单包和集中包怎么选，下载需要付费吗？",
    "answer": "只做一项任务可选单包，批量准备可选集中包。Skills 安装说明包可免费下载，与 Codex 助手客户端安装包的发布状态分别查看。下载后复制对应完整指令，将文件和指令一起发给 macOS Codex；模型和外部工具费用按所用服务确认。",
    "href": "#skills",
    "action": "选择 Skill 技能"
  },
  {
    "id": "faq-skill-start",
    "question": "下载了 Skill，接下来怎么用？",
    "answer": "在浏览器下载记录中找到安装包，再复制对应的安装话术，把文件和话术一起发给 macOS Codex。安装完成后打开项目里的“使用说明｜先从这里开始”，把占位内容换成真实需求并提供资料。安装包用于准备项目，业务成果需要在提交真实需求后生成。"
  },
  {
    "id": "faq-image",
    "question": "现在能直接在网页上生成图片吗？",
    "answer": "当前网页已开放文字生图，一次生成一张，暂不支持参考图与并发生成。登录后按页面提示确认模型授权并获取报价，实际尺寸和费用以当前创作页为准。结果未知时先查询原任务，避免重复提交。",
    "href": "#image-generation",
    "action": "前往文字生图"
  },
  {
    "id": "faq-image-settings",
    "question": "当前支持几张图片，可以用参考图或并发吗？",
    "answer": "当前每次生成一张图片，不支持参考图与并发生成。可用模型、尺寸和人民币费用以当前创作页的规格和报价为准；确认原任务结果后再决定是否发起新任务。"
  },
  {
    "id": "faq-video",
    "question": "视频复刻页面现在可以做什么？",
    "answer": "可从视频复刻入口整理创作需求。素材上传、草稿和生成以页面实际开放状态为准；未开放的操作不会模拟保存、任务成功或扣费。",
    "href": "#video-clone",
    "action": "整理视频需求"
  },
  {
    "id": "faq-video-materials",
    "question": "视频素材如何准备，下载需求会包含原文件吗？",
    "answer": "素材格式、大小、时长与数量以创作页面实际开放的规格为准。需求文本不能代替原始素材，请单独保留图片、视频、音频和参考文件；实际执行时按页面要求提供。素材上传和文档正文解析以实际服务状态为准。"
  },
  {
    "id": "faq-drafts",
    "question": "点了“保存草稿”，刷新或离开后还在吗？",
    "answer": "只有在页面明确显示保存成功后，才能确认草稿已保存。草稿服务尚未开放时，请单独保留需求和原始素材。"
  },
  {
    "id": "faq-results",
    "question": "创作成果在哪里？换电脑会自动恢复吗？",
    "answer": "Skill 任务成果保存在对应 Codex 项目中。网页作品、素材和跨设备恢复以实际服务状态为准；登录账户不会自动迁移本地文件。"
  },
  {
    "id": "faq-appearance",
    "question": "首页模板、深浅色和中英文怎么切换？",
    "answer": "首页模板可通过完整预览查看视觉效果；预览不会发布站点设置。顶部可以切换深浅色和语言，模板主视觉保留自身配色。站点模板与品牌发布服务尚待开放。",
    "href": "/?homePreview=glass",
    "action": "完整预览首页模板"
  },
  {
    "id": "faq-support",
    "question": "连接异常或设置不对时，应该先做什么？",
    "answer": "先在桌面助手中确认 Codex 已安装或已选择，检查当前账户与网络状态，再按页面提示重新检查连接与模型列表。保留现有配置和错误提示；需要恢复旧设置时，先联系为你提供服务的客服确认处理方式。求助时提供发生时间、所在功能、操作步骤和页面错误提示，订单问题另附订单号。",
    "href": "#tutorial",
    "action": "查看使用指南"
  },
  {
    "id": "faq-personal-services",
    "question": "发票、资料编辑、意见反馈和交流群在哪里？",
    "answer": "账户资料、通知、工单、发票和协议等入口将在服务开放后提供。当前不展示模拟资料、订单、收益或提现记录。"
  }
] as const;
